// extracted by mini-css-extract-plugin
module.exports = {"account_status_wrapper":"AccountStatusComponent_account_status_wrapper__1A41q","account_status_text":"AccountStatusComponent_account_status_text__O6Blg"};